import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2.5c-2.577 0-4.667 2.127-4.667 4.75S9.423 12 12 12s4.666-2.127 4.666-4.75S14.576 2.5 12 2.5Zm-2 4.75c0-1.124.895-2.036 2-2.036 1.104 0 2 .912 2 2.036s-.896 2.036-2 2.036c-1.105 0-2-.912-2-2.036Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.245 12.469a1.318 1.318 0 0 1 1.859-.323A6.633 6.633 0 0 0 12 13.405a6.633 6.633 0 0 0 3.896-1.26 1.318 1.318 0 0 1 1.859.324 1.373 1.373 0 0 1-.318 1.892 9.29 9.29 0 0 1-3.67 1.59l3.175 3.232c.521.53.521 1.39 0 1.92-.52.53-1.364.53-1.885 0L12 17.99l-3.057 3.111c-.521.53-1.365.53-1.886 0a1.375 1.375 0 0 1 0-1.919l3.176-3.233a9.29 9.29 0 0 1-3.67-1.59 1.373 1.373 0 0 1-.318-1.891Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconSocialOK24 = createIcon(IconComponent);